import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "@/pages/home/Home";
import NotFound from "@/pages/not-found/Index";

const ROUTE_PATHS = {
  HOME: "/",
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path={ROUTE_PATHS.HOME} element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
